import { parse as parseQuerystring } from 'querystringify';
import { getStore } from 'store';
import history from 'lib/history';
import * as analytics from 'analytics';
import graphql from 'api/graphql';
import { searchActions } from './actions-const';

const NUMBER_OF_SAVES_IN_STORAGE = 20;

function updateLocation() {
  return (dispatch, getState) => {
    const {
      search: { isActive, query },
    } = getState();

    const locationSearch = isActive ? `?search=${encodeURIComponent(query)}` : undefined;

    if (locationSearch !== history.location.search) {
      history.push({
        pathname: history.location.pathname,
        search: locationSearch,
      });
    }
  };
}

export function setActive(shouldBeActive) {
  return (dispatch, getState) => {
    const {
      search: { isActive },
    } = getState();
    if (isActive !== shouldBeActive) {
      dispatch({
        type: searchActions.SET_SEARCH_ACTIVE,
        active: shouldBeActive,
      });
      dispatch(updateLocation());
    }
  };
}

export function saveRecentSearch(targetType, uri) {
  return (dispatch, getState) => {
    const {
      search: { recentItems },
    } = getState();
    if (!recentItems.some((el) => el.uri === uri)) {
      recentItems.unshift({ uri, targetType });
    }
    if (recentItems.length >= NUMBER_OF_SAVES_IN_STORAGE) {
      recentItems.splice(NUMBER_OF_SAVES_IN_STORAGE);
    }
    dispatch({ type: searchActions.SET_SEARCH_RECENT, recentItems });
  };
}

export function removeItemFromRecentSearch(uri) {
  return (dispatch, getState) => {
    const {
      search: { recentItems },
    } = getState();
    dispatch({
      type: searchActions.SET_SEARCH_RECENT,
      recentItems: recentItems.filter((el) => el.uri !== uri),
    });
  };
}

export function clearRecentSearch() {
  return (dispatch) => {
    dispatch({ type: searchActions.SET_SEARCH_RECENT, recentItems: [] });
  };
}

export function setHidden(shouldBeHidden) {
  return (dispatch, getState) => {
    const {
      search: { hidden },
    } = getState();
    if (hidden !== shouldBeHidden) {
      dispatch({ type: searchActions.HIDE_SEARCH, hidden: shouldBeHidden });
      dispatch(updateLocation());
    }
  };
}

export function search(query, timeout) {
  let intervalId;
  return (dispatch) => {
    dispatch({ type: searchActions.SET_SEARCH_QUERY, query });
    dispatch(updateLocation());

    async function performSearch() {
      clearInterval(intervalId);
      let results = {};
      const startSearchTime = performance.now();

      if (query.length >= 1) {
        dispatch({ type: searchActions.SEARCH_IS_LOADING });
      }
      results = await graphql.fetchSearch(query);

      // UI fix - timeout prevents the search results to show up before the search background
      setTimeout(() => {
        if (query.length >= 1) {
          dispatch({ type: searchActions.SET_SEARCH_RESULTS, results });
          // check search time
          let searchTime = null;
          if (results) {
            const endSearchTime = performance.now();
            searchTime = endSearchTime - startSearchTime;
          }
          analytics.trackSearch(query, results, searchTime);
        }
      }, timeout);
    }
    intervalId = setInterval(performSearch, 100);
  };
}

function determineSearchState() {
  return (dispatch, getState) => {
    const {
      search: { isActive, query: queryFromState },
    } = getState();
    const { search: query } = parseQuerystring(history.location.search);
    if (query === undefined && isActive) {
      dispatch(setActive(false));
    } else if (queryFromState && isActive) {
      dispatch(search(queryFromState, 500));
    } else if (typeof query === 'string' && !isActive) {
      dispatch(search(query));
    }
  };
}

export function parseInitialSearch() {
  return (dispatch) => {
    dispatch(determineSearchState());
  };
}

history.listen(() => {
  getStore().dispatch(determineSearchState());
});
